import { createContext, useContext, useState, useEffect } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { getGoogleMapKey } from '../utils/getGoogleMapKey';

const GoogleMapsContext = createContext({ isLoaded: false, loadError: null });

const GoogleMapsLoader = ({ apiKey, children }) => {
    const { isLoaded, loadError } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: apiKey,
    });

    const contextValue = {
        isLoaded,
        loadError,
    };

    return (
        <GoogleMapsContext.Provider value={contextValue}>
            {children}
        </GoogleMapsContext.Provider>
    );
};

export const GoogleMapsProvider = ({ children }) => {
    const [googleMapsApiKey, setGoogleMapsApiKey] = useState(null);

    useEffect(() => {
        const fetchKey = async () => {
            const key = await getGoogleMapKey();
            setGoogleMapsApiKey(key);
        };

        fetchKey();
    }, []);

    // Don't render the loader until we have the API key
    if (!googleMapsApiKey) {
        return (
            <GoogleMapsContext.Provider value={{ isLoaded: false, loadError: null }}>
                {children}
            </GoogleMapsContext.Provider>
        );
    }

    return <GoogleMapsLoader apiKey={googleMapsApiKey}>{children}</GoogleMapsLoader>;
};

export const useGoogleMaps = () => {
    const context = useContext(GoogleMapsContext);
    if (context === undefined) {
        throw new Error('useGoogleMaps must be used within a GoogleMapsProvider');
    }
    return context;
};
